import request from '@/utils/request'
import { reqpost } from '../utils/axiosFun';
export function checkPhone(params) { // 判断电话是否存在，存在即登录
    return request({
        url: '/FHADMINM/wxmstuser/checkphonenum.do',
        method: 'get',
        params
    })
}
export function getuserinfo(params) { // 根据userid获取用户信息
    return request({
        url: '/FHADMINM/wxmstuser/getuserinfobyuserid.do',
        method: 'get',
        params
    })
}
export function userLogin(params) { // params
    return request({
        url: '/FHADMINM/wxmstuser/userlogin.do',
        method: 'get',
        params
    })
}
export function updateuserlogintimes(params) { // 计数器加1
    return request({
        url: '/FHADMINM/wxmstuser/updateuserlogintimes.do',
        method: 'get',
        params
    })
}
export function testpost(data) { // params
    return request({
        url: '/FHADMINM/wxmstuser/userlogin.do',
        method: 'post',
        data
    })
}
export function saveUserToken(params) { // 保存用户token 用于限制用户登录
    return request({
        url: '/FHADMINM/wxmstuser/savePCUserToKEN.do',
        method: 'get',
        params
    })
}
export function getcustomerlist(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/findbyuseridwithcat.do',
        method: 'get',
        params
    })
}
export function addcustomer(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/save.do',
        method: 'get',
        params
    })
}
export function getcustomerbyname(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/list.do',
        method: 'get',
        params
    })
}
export function getcustomergroup(params) { // params
    return request({
        url: '/FHADMINM/wxmstcuscatalog/findbyuserid.do',
        method: 'get',
        params
    })
}
export function getcustomer(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/viewcustomerbycatid.do',
        method: 'get',
        params
    })
}
export function checkname(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/checkcusnamebyuserid.do',
        method: 'get',
        params
    })
}
export function checkphone(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/checkphonenum.do',
        method: 'get',
        params
    })
}
export function checkgroup(params) { // params
    return request({
        url: '/FHADMINM/wxmstcuscatalog/checkNamebyuserid.do',
        method: 'get',
        params
    })
}
export function addgroup(params) { // params
    return request({
        url: '/FHADMINM/wxmstcuscatalog/save.do',
        method: 'get',
        params
    })
}
export function del(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/delete.do',
        method: 'get',
        params
    })
}
export function upd(params) { // params
    return request({
        url: '/FHADMINM/wxmstcustomer/edit.do',
        method: 'get',
        params
    })
}
export function del2(params) { // params
    return request({
        url: '/FHADMINM/wxmstcuscatalog/delete.do',
        method: 'get',
        params
    })
}
export function upd2(params) { // params
    return request({
        url: '/FHADMINM/wxmstcuscatalog/edit.do',
        method: 'get',
        params
    })
}
export function updatepass(params) { // params
    return request({
        url: '/FHADMINM/wxmstuser/resetpwd.do',
        method: 'get',
        params
    })
}
export function getgoodslist(params) {//获取商品列表
    return request({
        url: '/FHADMINM/wxmstgoods/list.do',
        method: 'get',
        params
    })
}
export function listmodcatlog(params) {//获取批量修改商品分类商品列表
    return request({
        url: '/FHADMINM/wxmstgoods/listmodcatlog.do',
        method: 'get',
        params
    })
}
export function getgoodsspecifications(params) {
    return request({
        //url: '/FHADMINM/wxmstgoods/findGoodspecgoodidin.do',
        url: '/FHADMINM/wxmstgoods/findGoodspecgoodid1.do',
        method: 'get',
        params
    })
}
export function getcustomermessage(params) {
    return request({
        url: '/FHADMINM/wxmstgoods/findGoodspecgoodid1.do',
        method: 'get',
        params
    })
}
export function checkarrears(params) { //查询用户欠款根据userid和cusid
    return request({
        url: '/FHADMINM/wxmstoutstockorder/gettodayoutnumbyuserid.do',
        method: 'get',
        params
    })
}
export function getpayway(params) {
    return request({
        url: '/FHADMINM/wxmstdict/mlist.do',
        method: 'get',
        params
    })
}
export function getcouriercompany(params) {
    return request({
        url: '/FHADMINM/wxmstdict/mlist.do',
        method: 'get',
        params
    })
}
export function deletepic(params) {
    return request({
        url: '/FHADMINM/wxmstgoods/deletefile.do',
        method: 'get',
        params
    })
}
export function savearraydraft(params) {
    return request({
        url: '/FHADMINM/wxmstoutstock/savearraydraft.do',
        method: 'get',
        params
    })
}
export function savearray1(params) {
    return request({
        url: '/FHADMINM/wxmstoutstock/savearray1.do',
        method: 'get',
        params
    })
}
export function savearray3(params) { // 入库
    return reqpost(
        "post",
        "/FHADMINM/wxmstoutstock/savearray3.do",
        params
    )
}
// export function savearray3(params) {
//     return request({
//         url: '/FHADMINM/wxmstoutstock/savearray3.do',
//         method: 'get',
//         params
//     })
// }
export function getgoodsbygroup(params) { //通过userid拿商品分类
    return request({
        url: '/FHADMINM/wxmstcatalog/findbyuserid.do',
        method: 'get',
        params
    })
}
export function finddefaultcatalogidbyuserid(params) { //通过userid拿商品默认分类
    return request({
        url: '/FHADMINM/wxmstcatalog/finddefaultcatalogidbyuserid.do',
        method: 'get',
        params
    })
}
export function tuihuo(params) {
    return request({
        url: '/FHADMINM/wxmstoutstock/returnout2.do',
        method: 'get',
        params
    })
}
export function deletegoods(params) {
    return request({
        url: '/FHADMINM/wxmstoutstock/delete.do',
        method: 'get',
        params
    })
}
export function submitupdate(params) {
    return request({
        url: '/FHADMINM/wxmstoutstockorder/editorder.do',
        method: 'get',
        params
    })
}
export function submitupdate1(params) {
    return request({
        url: '/FHADMINM/wxmstoutstockorder/editorder1.do',
        method: 'get',
        params
    })
}
export function editarraydraft(params) {
    return request({
        url: '/FHADMINM/wxmstoutstock/editarraydraft.do',
        method: 'get',
        params
    })
}
export function finddefaultsupplyByUserId(params) { //读取默认供应商
    return request({
        url: '/FHADMINM/wxmstsupplyshop/finddefaultsupplyByUserId.do',
        method: 'get',
        params
    })
}
export function finddefaultcusByUserId(params) { //读取默认客户
    return request({
        url: '/FHADMINM/wxmstcustomer/finddefaultcusByUserId.do',
        method: 'get',
        params
    })
}
export function checkCustomerNameByExcel(params) { //Excel导入客户校验
    return request({
        url: '/FHADMINM/wxmstcustomer/checkcustomername.do',
        method: 'get',
        params
    })
}
export function checkGoodsByExcel(params) { //Excel导入商品校验
    return request({
        url: '/FHADMINM/wxmstgoods/checkgoodsbyexcel.do',
        method: 'get',
        params
    })
}
export function checkGoodsSpecByExcel(params) { //Excel导入规格校验
    return request({
        url: '/FHADMINM/wxmstgoodsspec/checkspecbygoodsid.do',
        method: 'get',
        params
    })
}
export function viewmysubusernumber(params) { //查看是否有子账户
    return request({
        url: '/FHADMINM/wxmstuser/viewmysubusernumber.do',
        method: 'get',
        params
    })
}
export function findproductcategory(params) { //查询所有分类
    return request({
        url: '/FHADMINM/wxmstcatalog/findbyuserid.do',
        method: 'get',
        params
    })
}
export function findsecondproductcategory(params) { //查询二级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/findsubcatbyuserid.do',
        method: 'get',
        params
    })
}
export function addfirstclass(params) { //创建一级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/save.do',
        method: 'get',
        params
    })
}
export function addSecondclass(params) { //创建二级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/savesubid.do',
        method: 'get',
        params
    })
}
export function editfirstclass(params) { //修改一级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/edit.do',
        method: 'get',
        params
    })
}
export function editSecondclass(params) { //修改二级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/editsub.do',
        method: 'get',
        params
    })
}
export function deleteFirstclass(params) { //删除一级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/delete.do',
        method: 'get',
        params
    })
}
export function deleteSecondclass(params) { //删除二级分类
    return request({
        url: '/FHADMINM/wxmstcatalog/deletesub.do',
        method: 'get',
        params
    })
}
export function findallspec(params) { //查询所有多规格模板
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/findbyuserid.do',
        method: 'get',
        params
    })
}
export function addFirstspec(params) { //新增一级多规格
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/save.do',
        method: 'get',
        params
    })
}
export function addSecondspec(params) { //新增二级多规格
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/savesubid.do',
        method: 'get',
        params
    })
}
export function editFirstspec(params) { //修改一级多规格
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/edit.do',
        method: 'get',
        params
    })
}
export function editSecondspec(params) { //修改二级多规格
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/editsub.do',
        method: 'get',
        params
    })
}
export function deleteFirstspec(params) { //删除一级分类
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/delete.do',
        method: 'get',
        params
    })
}
export function deleteSecondspec(params) { //删除一级分类
    return request({
        url: '/FHADMINM/wxmstgoodspectemplate/deletesub.do',
        method: 'get',
        params
    })
}
export function editgoodscatlog(params) { //修改商品分类
    return request({
        url: '/FHADMINM/wxmstgoods/editgoodscatlog.do',
        method: 'get',
        params
    })
}
export function editoutgoodslist(params) { //修改出库单商品
    return request({
        url: '/FHADMINM/wxmstoutstock/savegoods.do',
        method: 'post',
        params
    })
}
export function findgoodbybarcodeanduserid(params) { //判断条形码是否存在
    return request({
        url: '/FHADMINM/wxmstgoods/findgoodbybarcodeanduserid.do',
        method: 'post',
        params
    })
}
export function selectcustomer(params) { //查询客户详情
    return request({
        url: '/FHADMINM/wxmstcustomer/findbyid.do',
        method: 'post',
        params
    })
}
export function getCustomerOwnfee(params) { //获取用户欠款
    return request({
        url: '/FHADMINM/wxmstoutstockorder/gettodayoutnumbyuserid.do',
        method: 'post',
        params
    })
}
export function getConfirMoney(params) { //获取累计销售金额
    return request({
        url: '/FHADMINM/wxmstoutstock/totalpricebycustomerid.do',
        method: 'post',
        params
    })
}
export function selectcustomerarrears(params) { //查看用户欠款详情
    return request({
        url: '/FHADMINM/wxmstoutstockorder/mlist.do',
        method: 'post',
        params
    })
}
export function oftengoods(params) { //常购商品
    return request({
        url: '/FHADMINM/wxmstcustomergoods/mlist.do',
        method: 'post',
        params
    })
}
export function consumptionrecord(params) { //消费记录
    return request({
        url: '/FHADMINM/wxmstprepaymentdetail/mlist.do',
        method: 'post',
        params
    })
}
export function historyorder(params) { //获取历史出库订单列表
    return request({
        url: '/FHADMINM/wxmstoutstock/list.do',
        method: 'get',
        params
    })
}
export function historyinorder(params) { //获取历史入库单
    return request({
        url: '/FHADMINM/wxmstinstocks/list.do',
        method: 'get',
        params
    })
}
export function colmoney(params) { //获取历史收款
    return request({
        url: '/FHADMINM/wxmstreceiptmain/mlist.do',
        method: 'get',
        params
    })
}
export function colinmoney(params) { //获取历史入库付款
    return request({
        url: '/FHADMINM/wxmstpaymentmain/mlist.do',
        method: 'get',
        params
    })
}
export function outdetails(params) { //获取出库历史收款
    return request({
        url: '/FHADMINM/wxmstoutstock/findbyid.do',
        method: 'get',
        params
    })
}
export function indetails(params) { //获取入库历史收款
    return request({
        url: '/FHADMINM/wxmstinstocks/findbyid.do',
        method: 'get',
        params
    })
}
export function addorsubMoney(params) { //充值消费
    return request({
        url: '/FHADMINM/wxmstprepaymentdetail/reneworsubmoney.do',
        method: 'get',
        params
    })
}

export function oftensupplygoods(params) { //供应商常购商品
    return request({
        url: '/FHADMINM/wxmstsupplyshopgoods/mlist.do',
        method: 'get',
        params
    })
}
export function gettotalowncusbyuserid(params) { //读取欠款客户数
    return request({
        url: '/FHADMINM/wxmstoutstockorder/gettotalowncusbyuserid.do',
        method: 'get',
        params
    })
}
export function gettotalownfeebyuserid(params) { //读取欠款总数
    return request({
        url: '/FHADMINM/wxmstoutstockorder/gettotalownfeebyuserid.do',
        method: 'get',
        params
    })
}
export function receiptviewbymstid(params) { //查看收款单详情
    return request({
        url: '/FHADMINM/wxmstreceiptmain/findbyid.do',
        method: 'get',
        params
    })
}
export function getgoodsaledetaildata(params) { //显示客户销售明细
    return request({
        url: '/FHADMINM/wxmstoutstock/getgoodsaledetaildata.do',
        method: 'get',
        params
    })
}
export function getgoodinstocksdetaildata(params) { // 显示客户进货明细
    return request({
        url: '/FHADMINM/wxmstinstocks/getgoodinstocksdetaildata.do',
        method: 'get',
        params
    })
}
export function deletereceiptbyid(params) { // 删除收款单
    return request({
        url: '/FHADMINM/wxmstreceiptmain/delete.do',
        method: 'get',
        params
    })
}
export function mreceiptnopaylist(params) { // 获取未付款账单
    return request({
        url: '/FHADMINM/wxmstoutstockorder/mreceiptnopaylist.do',
        method: 'get',
        params
    })
}
export function savereceipt(params) { // 保存收款单
    return reqpost(
        "post",
        "/FHADMINM/wxmstreceiptmain/save.do",
        params
    )
}
// export function savereceipt(params) { // 保存收款单
//     return request({
//         url: '/FHADMINM/wxmstreceiptmain/save.do',
//         method: 'post',
//         params:params,
//         data : {unused: 0},
//         // headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
//         headers:{
//             'Content-Type':'application/x-www-form-urlencoded'
//         }
//     })
// }
export function gettotalownsupplybyuserid(params) { //读取供应商数
    return request({
        url: '/FHADMINM/wxmstinstocksorder/gettotalownsupplybyuserid.do',
        method: 'get',
        params
    })
}
export function getinstockstotalownfeebyuserid(params) { //读取欠款总数
    return request({
        url: '/FHADMINM/wxmstinstocksorder/gettotalownfeebyuserid.do',
        method: 'get',
        params
    })
}
export function paymentviewbymstid(params) { //查看付款单详情
    return request({
        url: '/FHADMINM/wxmstpaymentmain/findbyid.do',
        method: 'get',
        params
    })
}
export function mpaymentnopaylist(params) { // 获取未支付账单
    return request({
        url: '/FHADMINM/wxmstinstocksorder/mpaymentnopaylist.do',
        method: 'get',
        params
    })
}
export function deletepaymentbyid(params) { // 删除付款单
    return request({
        url: '/FHADMINM/wxmstpaymentmain/delete.do',
        method: 'get',
        params
    })
}
export function getOPDBToken(params) { //获取token
    return request({
        url: '/FHADMINM/wxmstuser/getOPDBToken.do',
        method: 'get',
        params
    })
}
export function listdefaultpriecByCusid(params) { //根据客户id读取客户所在分组默认售价
    return request({
        url: '/FHADMINM/wxmstcustomer/listdefaultpriecByCusid.do',
        method: 'get',
        params
    })
}
export function savepayment(params) { // 保存收款单
    return reqpost(
        "post",
        "/FHADMINM/wxmstpaymentmain/save.do",
        params
    )
}
// export function savepayment(params) { // 保存收款单
//     return request({
//         url: '/FHADMINM/wxmstpaymentmain/save.do',
//         method: 'get',
//         params
//     })
// }
export function savecompanyinfo(params) { // 新建商家单位设置
    return request({
        url: '/FHADMINM/wxmstprintconfig/savecompanyinfo.do',
        method: 'post',
        params
    })
}
export function editCompanyinfo(params) { // 修改商家单位设置
    return request({
        url: '/FHADMINM/wxmstprintconfig/editCompanyinfo.do',
        method: 'post',
        params
    })
}
export function findR2to6ById(params) {//获取基本数据配额条数,商品,供应商,客户,入库,出库
    return request({
        url: '/FHADMINM/wxmstuserconfig/findR2to6ById.do',
        method: 'get',
        params
    })
}
export function getInfoCountInandOut(params) {//获取当前出入库明细数量
    return request({
        url: '/FHADMINM/wxmstuser/getInfoCountInandOut.do',
        method: 'get',
        params
    })
}
export function wxstpaybyQrCode(params) { // 获取微信支付二维码
    return reqpost(
        "post",
        "/FHADMINM/wxpay/wxstpaybyQrCode.do",
        params
    )
}
export function findByouttradeno(params) {//按订单号查询是否续费
    return request({
        url: '/FHADMINM/wxmstrenew/findByouttradeno.do',
        method: 'get',
        params
    })
}
export function viewownrenewlist(params) {//续费记录
    return request({
        url: '/FHADMINM/wxmstuser/viewownrenewlist.do',
        method: 'get',
        params
    })
}